import React, { useState, useEffect } from 'react';
import {
  HomeIcon,
  PencilIcon,
  BuildingLibraryIcon,
  UserCircleIcon,
} from '@heroicons/react/24/outline';
import {
  Typography,
  Card,
  CardBody,
  Input,
  Slider,
  Button,
  Spinner,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  slider,
} from '@material-tailwind/react';

import {
  Routes,
  Route,
  useNavigate,
  Link,
  useLocation,
} from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import Mint from './Mint';
import Connect from '../components/Connect';
import Explorer from './Explorer';
import Admin from './Admin';
import Disclaimer from './Disclaimer';
import Test from './Test';
import MintTest from './MintTest';
import Metadata from './Metadata';
import TestNew from './TestNew';
import Header from '../components/Header';
import Home from './Home';
import MenuBar from '../components/MenuBar';
import { mintTotal } from '../util/api';
import News from './News';
import Maintenance from './Maintenance';
import { getAdminData } from '../util/api';

export default function Indexer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [tab, setTab] = useState(0); //0: Wallet 1: Mint Domain 2: Explorer
  const [rightMenu, setRightMenu] = useState(false);
  const [deployCount, setDeployCount] = useState(0);

  const [isMaintenance, setIsMaintenance] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    handleUpdateCounts();
    handleMaintenance();
  }, []);

  const handleMaintenance = async () => {
    setIsLoading(true);
    let results = await getAdminData();
    setIsMaintenance(results.isMaintenance);
    setIsLoading(false);
  };

  const handleUpdateCounts = async () => {
    let results = await mintTotal();
    setDeployCount(results.data);
  };

  const openRightMenu = () => {
    setRightMenu(true);
  };

  const closeRightMenu = () => {
    setRightMenu(false);
  };

  const handleTab = (tab) => {
    setTab(tab);
    switch (tab) {
      case 0:
        navigate('/');
        break;
    }
  };

  if (isLoading) {
    return (
      <div className='flex flex-col bg-background items-center w-full h-screen justify-center'>
        <Spinner className='h-12 w-12' />
      </div>
    );
  }

  return (
    <div className='flex flex-col bg-background items-center w-full'>
      {location.pathname == '/maintenance' ? (
        <></>
      ) : (
        <Header openRightMenu={openRightMenu} deployCount={deployCount} />
      )}
      <MenuBar
        openRightMenu={openRightMenu}
        closeRightMenu={closeRightMenu}
        rightMenu={rightMenu}
        deployCount={deployCount}
      />
      {/* {
        location.pathname == '/' ? 
          <div className="flex flex-row-reverse z-[9] w-full md:mt-5 mt-0 md:pr-4 pr-3">
            <Connect />
          </div>
          :
          <></>
      } */}
      <Routes>
        <Route path='/about' element={<Home isMaintenance={isMaintenance} />} />
        <Route path='/news' element={<News isMaintenance={isMaintenance} />} />
        <Route path='/maintenance' element={<Maintenance />} />
        <Route path='/' element={<Mint isMaintenance={isMaintenance} />} />
        <Route
          path='/index'
          element={<Explorer isMaintenance={isMaintenance} />}
        />
        <Route
          path='/metadata'
          element={<Metadata isMaintenance={isMaintenance} />}
        />
        <Route
          path='/disclaimer'
          element={<Disclaimer isMaintenance={isMaintenance} />}
        />
        <Route
          path='/admin'
          element={<Admin isMaintenance={isMaintenance} />}
        />
        <Route
          path='/__test'
          element={<Test isMaintenance={isMaintenance} />}
        />
        <Route
          path='/__testNew'
          element={<MintTest isMaintenance={isMaintenance} />}
        />
        <Route
          path='/__testNew1'
          element={<TestNew isMaintenance={isMaintenance} />}
        />
      </Routes>
    </div>
  );
}
